<template>
    <div class="code-view-main" v-if="url">
        <img :src="url" style="width: 95px;height: 95px;">
        <span style="font-size: 10px;color: #333333;margin-top: 5px;">扫码关注微信公众号</span>
    </div>
</template>

<script>
    import {request} from "@/api/request";
    import EventBus from "@/api/EventBus";
    import webConfig from "@/api/config";

    export default {
        name: "GzhCodeView",
        props: {
            weChatUrl: {
              type: String,
              default: ''
            }          
        },
        data(){
          return {
            url: ''
          }
        },
        mounted() {
          this.initPage();
        },
        methods: {
            initPage() {
                this.url = webConfig.wechatUrl;
            },
        }
    }
</script>

<style scoped>
    .code-view-main {
        position: fixed;
        right: 30px;
        top: 45%;
        padding: 10px;
        background-color: #ffffff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 999;
    }
</style>